// extracted by mini-css-extract-plugin
module.exports = {"skeleton-card":"skeleton_skeleton-card__Lgrgu","skeleton-image":"skeleton_skeleton-image__7mr1f","skeleton-text":"skeleton_skeleton-text__1tzzp"};